import {css, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import Decimal from './break_infinity.js';
import {Cost} from './interfaces/dynamic-value.js';
import {LogEntry} from './log';
import {ri} from './runner-idle.js';
import {formatEng, formatTime} from './utils.js';

@customElement('ri-activity-log-entry')
export class ActivityLogEntry extends LogEntry {
  // #region Properties (6)

  public static override styles = [
    ...LogEntry.styles,
    css`
      .msg-header {
        font-size: 1rem;
        min-width: 96px;
      }
    `,
  ];

  public cost: Cost = new Map();
  public override displayName = '';
  public effect: Cost = new Map();
  public logString = '';
  public override name = '';

  // #endregion Properties (6)

  // #region Public Methods (2)

  public add(data: {cost: Cost; effect: Cost}) {
    this.duration += 1;
    const {cost, effect} = data;
    for (const [key, {value, string: str}] of cost) {
      if (this.cost.has(key)) {
        const {value: oldValue, string: oldString} = this.cost.get(key)!;
        this.cost.set(key, {
          value: new Decimal(oldValue).add(value),
          string: `${oldString} + ${str}`,
        });
      } else {
        this.cost.set(key, {value, string: str});
      }
    }
    for (const [key, {value, string: str}] of effect) {
      if (this.effect.has(key)) {
        const {value: oldValue, string: oldString} = this.effect.get(key)!;
        this.effect.set(key, {
          value: new Decimal(oldValue).add(value),
          string: `${oldString} + ${str}`,
        });
      } else {
        this.effect.set(key, {value, string: str});
      }
    }
    this.requestUpdate();
  }

  public override render() {
    if (ri.settings.scrollLogToNew) setTimeout(() => this._scrollIntoView());
    return html`<div class="container">
      <div class="header">
        ${`${this.life > 0 ? `${this.life}-` : ''} ${formatTime(
          this.tick,
          true
        )}`}
      </div>
      <div class="msg">
        <span class="msg-header">
          <span class="fancy ${this.name}">
            ${this.displayName}${this.duration > 1 ? ` x${this.duration}` : ''}
          </span>
        </span>
        ${this.logString}<span class="effect"
          >Gain
          ${unsafeHTML(
            [...this.effect]
              .filter(
                ([k, {value}]) =>
                  !new Decimal(value).eq(0) && ri?.get(k)?.unlocked
              )
              .map(
                ([k, v]) =>
                  `<span class='fancy ${k}'>${formatEng(v.value)}</span> ${
                    ri?.get(k)?.displayName
                  }`
              )
              .join(', ')
          )}</span
        ><span class="expand"></span>${this.cost.size > 0
          ? unsafeHTML(
              `Cost ${[...this.cost]
                .filter(
                  ([k, {value}]) =>
                    new Decimal(value).gt(0) && ri?.get(k)?.unlocked
                )
                .map(
                  ([k, v]) =>
                    `<span class='fancy ${k}'>-${formatEng(v.value)}</span> ${
                      ri?.get(k)?.displayName
                    }`
                )
                .join(', ')}`
            )
          : ''}
      </div>
    </div>`;
  }

  // #endregion Public Methods (2)
}
